var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-/-Empresa->-1",
    transform: "translate(-448.000000, -430.000000)",
    stroke: "#B2B2B2",
    fillRule: "nonzero",
    fill: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("g", {
    id: 159694,
    transform: "translate(201.000000, 421.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(237.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5132383,23.0203666 L20.7230143,18.8105906 C21.0162933,18.5173116 21.0162933,18.0468432 20.7230143,17.7535642 C20.4297352,17.4602851 19.9592668,17.4602851 19.6659878,17.7535642 L16.7331976,20.6863544 L16.7331976,9.47454175 C16.7331976,9.05906314 16.3971487,8.72301426 15.9816701,8.72301426 C15.5661914,8.72301426 15.2301426,9.05906314 15.2301426,9.47454175 L15.2301426,20.6802444 L12.2973523,17.7474542 C12.0040733,17.4541752 11.5336049,17.4541752 11.2403259,17.7474542 C10.9470468,18.0407332 10.9470468,18.5112016 11.2403259,18.8044807 L15.4501018,23.0142566 C15.5967413,23.1608961 15.7861507,23.2342159 15.9816701,23.2342159 C16.1771894,23.2342159 16.3665988,23.1670061 16.5132383,23.0203666 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.21dcd0d46f2ec572aae809ac984932b6.svg";
export { ForwardRef as ReactComponent };